import dayjs from 'dayjs'

import { formatDate } from '#/shared/lib/format'

import type { ActivityHistoryEntry } from './types'

export interface ActivityHistoryDayGroup {
  key: string
  label: string
  entries: ActivityHistoryEntry[]
}

const DAY_FORMAT = 'YYYY-MM-DD'

function dayLabel(
  key: string,
  today: dayjs.Dayjs,
  prefixToday: string,
  prefixYesterday: string,
): string {
  const date = dayjs(key)
  const formatted = formatDate(key).toUpperCase()
  if (date.isSame(today, 'day')) return `${prefixToday} · ${formatted}`
  if (date.isSame(today.subtract(1, 'day'), 'day'))
    return `${prefixYesterday} · ${formatted}`
  return formatted
}

export function groupEntriesByDay(
  entries: ActivityHistoryEntry[],
  labels: { today: string; yesterday: string },
): ActivityHistoryDayGroup[] {
  const today = dayjs()
  const buckets = new Map<string, ActivityHistoryEntry[]>()
  for (const entry of entries) {
    const key = dayjs(entry.occurredAt).format(DAY_FORMAT)
    const bucket = buckets.get(key)
    if (bucket) bucket.push(entry)
    else buckets.set(key, [entry])
  }
  return Array.from(buckets.entries())
    .sort((a, b) => (a[0] < b[0] ? 1 : -1))
    .map(([key, items]) => ({
      key,
      label: dayLabel(key, today, labels.today, labels.yesterday),
      entries: items,
    }))
}
